module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Shopping/Cart#2-88542e0fab9b08aa8e2388b41987fcb5.svg";